import script from "./PageContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageContent.vue?vue&type=script&setup=true&lang=ts"

import "./PageContent.vue?vue&type=style&index=0&id=1f4a6a01&scoped=true&lang=less"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f4a6a01"]])

export default __exports__